import React from 'react';
import { Button } from '@/components/ui/button';
import { POWERCLOUD_URL } from '@/constants/powercloud';
import { Stage, useStage } from '@/hooks/useStage';
import { VorgangDetail } from '@/types';

interface PowercloudButtonLinkProps {
  vorgang: VorgangDetail;
}

export const PowercloudButtonLink: React.FC<PowercloudButtonLinkProps> = ({
  vorgang,
}) => {
  const stage = useStage();
  const baseUrl =
    stage === Stage.PROD ? POWERCLOUD_URL.BASE.PROD : POWERCLOUD_URL.BASE.TEST;
  const path = vorgang.vertragsnummer
    ? POWERCLOUD_URL.PATH.VERTRAG.replace(
        '{vertragsnummer}',
        vorgang.vertragsnummer,
      )
    : POWERCLOUD_URL.PATH.AUFTRAG.replace(
        '{auftragsnummer}',
        vorgang.auftragsnummer,
      );

  return (
    <Button
      variant="default"
      size="sm"
      asChild
      className="bg-yellow-400 hover:bg-yellow-500 text-black"
    >
      <a href={baseUrl + path} target="_blank" rel="noopener noreferrer">
        Powercloud
      </a>
    </Button>
  );
};
